import { render, staticRenderFns } from "./tablePrice.vue?vue&type=template&id=ab367526&scoped=true"
import script from "./tablePrice.vue?vue&type=script&lang=js"
export * from "./tablePrice.vue?vue&type=script&lang=js"
import style0 from "./tablePrice.vue?vue&type=style&index=0&id=ab367526&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab367526",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ab367526')) {
      api.createRecord('ab367526', component.options)
    } else {
      api.reload('ab367526', component.options)
    }
    module.hot.accept("./tablePrice.vue?vue&type=template&id=ab367526&scoped=true", function () {
      api.rerender('ab367526', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/collectionCenter/tablePrice.vue"
export default component.exports